var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
import { CHAR_COUNTER_CHILD } from './char-counter';
//namespace Pacem.Components.Scaffolding {
let PacemTextInputElement = class PacemTextInputElement extends PacemTextualInputElement {
    constructor() {
        super();
    }
    toggleReadonlyView(readonly) {
        this._span.hidden = !readonly;
        this._input.hidden = readonly;
    }
    get inputFields() {
        return [this._input];
    }
};
__decorate([
    ViewChild('input[type=text]')
], PacemTextInputElement.prototype, "_input", void 0);
__decorate([
    ViewChild('span.' + PCSS + '-readonly')
], PacemTextInputElement.prototype, "_span", void 0);
PacemTextInputElement = __decorate([
    CustomElement({
        tagName: P + '-input-text',
        template: `<input type="text" class="${PCSS}-input" />${CHAR_COUNTER_CHILD}<span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemTextInputElement);
export { PacemTextInputElement };
